import { bootstrapApplication } from "@angular/platform-browser";
import { defineCustomElements } from "@siemens/ix-brand-theme/loader";
import { AppComponent } from "./app/app.component";
import { appConfig } from "./app/app.config";

(async function main() {
  try {
    defineCustomElements();
    await bootstrapApplication(AppComponent, appConfig);
  } catch (err: unknown) {
    console.error(err);
  }
})();
